export default __webpack_public_path__ + "static/media/hht1_ep13_book_wp_02.1a68b097.jpg";